import { _ as __assign } from '../../../tslib/tslib.es6-LMiJArAJ.js';
import * as React from 'react';
import { a as invariant } from '../../../_formatjs/ecma402-abstract/lib/utils-DHZHYGB4.js';
import { D as DEFAULT_INTL_CONFIG$1 } from '../../../_formatjs/intl/lib/src/utils-BY-09i56.js';

function invariantIntlContext(intl) {
    invariant(intl, '[React Intl] Could not find required `intl` object. ' +
        '<IntlProvider> needs to exist in the component ancestry.');
}
var DEFAULT_INTL_CONFIG = __assign(__assign({}, DEFAULT_INTL_CONFIG$1), { textComponent: React.Fragment });
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */
function assignUniqueKeysToParts(formatXMLElementFn) {
    return function (parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn(React.Children.toArray(parts));
    };
}
function shallowEqual(objA, objB) {
    if (objA === objB) {
        return true;
    }
    if (!objA || !objB) {
        return false;
    }
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) {
        return false;
    }
    for (var i = 0; i < len; i++) {
        var key = aKeys[i];
        if (objA[key] !== objB[key] ||
            !Object.prototype.hasOwnProperty.call(objB, key)) {
            return false;
        }
    }
    return true;
}

export { DEFAULT_INTL_CONFIG as D, assignUniqueKeysToParts as a, invariantIntlContext as i, shallowEqual as s };
//# sourceMappingURL=utils-BIG_B-Jx.js.map
